import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import fileDownload from 'js-file-download';
import React, { useEffect, useState } from 'react';
import WindsorApi from '../../api/WindsorApi';
import LoadingButton from '../../common/LoadingButton';
import LoadingIndicator from '../../common/LoadingIndicator';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContent: { 
      width: 400 
    }
  })
);

interface Props {
  familyId: string;
  testName: string;
  onClose: (test?: any) => void;
}

const windsorApi = new WindsorApi();

function DownloadTestDialog(props: Props) {
  const { familyId, testName, onClose } = props;
  const classes = useStyles({});
  const [versions, setVersions] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState('');
  const [downloadInProgress, setDownloadInProgress] = useState(false);

  useEffect(() => {
    windsorApi.getTestVersions(familyId, testName).then(res => {
      setVersions(res);
      if (res.length) {
        // Set version to latest
        setSelectedVersion(res[0])
      }
    });
  }, [familyId, testName]);

  const onVersionChanged = (event: React.ChangeEvent<{ name?: string; value: string }>) => {
    setSelectedVersion(event.target.value);
  };

  const onDownload = () => {
    setDownloadInProgress(true);
    windsorApi.getTestVersion(familyId, testName, selectedVersion).then(data => {
      fileDownload(data, `${testName}_${selectedVersion}.zip`);
      setDownloadInProgress(false);
      onClose();
    });
  };

  return (<Dialog
    open={true}
    onClose={() => onClose()}
    disableBackdropClick={downloadInProgress}
    aria-labelledby="download-test-dialog-title"
    aria-describedby="download-test-dialog-description"
  >
    <DialogTitle id="download-test-dialog-title">Download Test Package</DialogTitle>
    <DialogContent className={classes.dialogContent}>
      <LoadingIndicator loading={!versions} />
      {versions && selectedVersion && <Select
        fullWidth
        value={selectedVersion}
        onChange={onVersionChanged}
      >
        {versions.map(version => <MenuItem key={version} value={version}>
          <ListItemText primary={version} />
        </MenuItem>)}
      </Select>}
    </DialogContent>
    <DialogActions>
      <Button disabled={downloadInProgress} onClick={() => onClose()} color="primary">
        Cancel
      </Button>
      <LoadingButton
        color="primary"
        variant="text"
        loading={downloadInProgress}
        onClick={onDownload}>
        Download
      </LoadingButton>
    </DialogActions>
  </Dialog>
  );
};

export default DownloadTestDialog;
